import { FC, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectTenantName, selectRole } from '@redux/slices/userSlice';

export const REQUIRED_TENANT = 'apple';
export const TENANT_REDIRECT_PATH = '/app/home/assigned-content';

const TenantRedirect: FC<{ children: ReactElement }> = ({ children }) => {
    const tenantName = useSelector(selectTenantName);
    const role = useSelector(selectRole);
    const location = useLocation();

    if (tenantName === REQUIRED_TENANT && role === 'user' && location.pathname === '/app/home') {
        return <Navigate to={TENANT_REDIRECT_PATH} replace />;
    }

    return children;
};

export default TenantRedirect;
